import { render, staticRenderFns } from "./details-field.vue?vue&type=template&id=695d4ec4&"
import script from "./details-field.vue?vue&type=script&lang=js&"
export * from "./details-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports